import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "30+ Years of Experience",
  "Regulated Canadian Immigration Consultant",
  "Ottawa, Canada",
  "Member in Good Standing · CICC",
  "Professional and Personalized Guidance",
];

export default function TrustMarquee() {
  return (
    <div
      data-testid="trust-marquee"
      className="border-y border-black/10 bg-charcoal py-5"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-8 text-white/90 font-heading text-lg sm:text-xl tracking-tight">
              {w}
            </span>
            <span className="w-2 h-2 rotate-45 bg-crimson" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
